import { Fragment, useEffect, useMemo, useState } from "react"
import { MainContainer } from "../../components"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useSelector } from "react-redux"
import { calculateTotalByKey, funCheckNumber, selectFilter } from "../../Utility/utility"
import * as XLSX from "xlsx";
import { autoTable } from "jspdf-autotable"
import jsPDF from "jspdf";

import { useNavigate } from "react-router-dom"
import { Select, SelectItem } from "@heroui/react"
import { Chip } from "@mui/material"

const SinglePktLotWiseStockDetail = () => {
  const { compCode,compName } = useSelector((state) => state.company);
  const { stockLotNo } = useSelector((state) => state.stockEntry);
  const [selLotNos, setSelLotNos] = useState(new Set(stockLotNo))
  const [data, setData] = useState([])
  const navigate = useNavigate();

  const { data: masterData = [] } = useFetchWithBody({
    url: apiRoute.stockEntry.getLotNosList,
    queryKey: "StockItemMaster",
    inputData: {
      comp_code: compCode.join(",")
    }
  })

  const { lotdata = [], mutate: filterData } = usePost({
    url: apiRoute.stockEntry.fetchLotStockDetail,
    queryKey: "lotwisestockDetailtck",
    onSuccessTasks: (data) => {
      setData(data)
    }
  });

  useEffect(() => {
    const arr = [...selLotNos];
    if (arr.length > 0) {
      filterData({
        data: {
          comp_code: compCode.join(","),
          trade_of: "P",
          l_code: arr.join(",")
        }
      });
    }
    else {
      setData([])
    }
  }, [selLotNos]);

  const thClass =
    "border border-gray-300 px-2 py-1  text-center text-xs font-semibold leading-tight bg-blue-100";

  const tdClass =
    "border border-gray-300 px-1 py-1 text-center";

  const tdRight =
    "border border-gray-300 px-1 py-1 text-right";
  const stickyHeader =
    "sticky top-0 z-10  bg-gray-100 text-sm";

  const stickyFooter =
    "sticky bottom-0 z-10 bg-gray-200 font-semibold";

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return "";
    return d.toLocaleDateString("en-GB"); // dd/mm/yyyy
  };


  // Keeps original order but groups rows under lot
  const groupedData = data.reduce((acc, row) => {
    const lotRaw = row.SL_Code || "UNKNOWN";
    const lotKey = lotRaw.toString().toUpperCase(); // case-insensitive key

    if (!acc[lotKey]) acc[lotKey] = [];
    acc[lotKey].push(row);

    return acc;
  }, {});


  // Object with lot totals
  const lotTotals = Object.fromEntries(
    Object.entries(groupedData).map(([lotNo, rows]) => {
      const totalPkt = rows.length;
      const totalInw = rows.reduce((t, r) => t + (r.Inw_Weight || 0), 0);
      const totalSaleWeight = rows.reduce((t, r) => t + (r.Sale_Weight || 0), 0);
      const totalSalePcs = rows.reduce((t, r) => t + (r.Sale_Pcs || 0), 0);

      const totalAmount = rows.reduce((t, r) => t + (r.Amount || 0), 0);
      let temp= totalAmount / totalSaleWeight
      const avgSaleRate = funCheckNumber(temp)
      const totalMemoWeight = rows.reduce((t, r) => t + (r.Memo_Weight || 0), 0);
      const totalMemoPcs = rows.reduce((t, r) => t + (r.Memo_Pcs || 0), 0);
      const totalStock = rows.reduce((t, r) => t + (r.Stock_Weight || 0), 0);
      const totalStockPcs = rows.reduce((t, r) => t + (r.Stock_Pcs || 0), 0);
      return [
        lotNo,
        { totalInw, totalSaleWeight, totalAmount, totalStock, totalMemoPcs, totalMemoWeight, totalPkt, totalSalePcs, avgSaleRate, totalStockPcs }
      ];
    })
  );
  const handleClickPrev = () => {
    navigate(linksUrl.rptSinglePktLotWiseStock);
  };
  const handleDelet = (key, name) => {

    const newFilter = selLotNos
    newFilter.delete(key)
    setSelLotNos(new Set(newFilter));

  }


  const exportToExcel = () => {
    if (!data || data.length === 0) return;

    const sheetData = [];
    const rowStyles = []; // Track row types

    /* ================= HEADER ================= */
    sheetData.push([
      "Sr No",
      "Lot No",
      "Pkt No",
      "Mkt No",
      "Inw Weight",
      "Mix-Sng Inw Weight",
      "Sale Weight",
      "Sale Pcs",
      "Sale Rate",
      "Sale Value",
      "Stock Weight",
      "Stock Pcs",
      "On Memo",
      "On Memo Pcs",
      "Trf To Mix",
      "Stock Location / Party",
      "Trn Date",
      "Doc No",
    ]);
    rowStyles.push("header");

    /* ================= BODY ================= */
    Object.entries(groupedData).forEach(([lotNo, rows]) => {
      // Lot Header
      sheetData.push([`Lot - ${lotNo}`]);
      rowStyles.push("lotHeader");

      rows.forEach((row, i) => {
        sheetData.push([
          i + 1,
          row.SL_Code,
          row.SPktNo,
          `${row.L_Code}-${row.PktNo}`,
          row.Inw_Weight || 0,
          row.MixSngInw_Weight || 0,
          row.Sale_Weight || "",
          row.Sale_Pcs || "",
          row.Sale_Rate || "",
          row.Amount || "",
          row.Stock_Weight || 0,
          row.Stock_Pcs || 0,
          row.Memo_Weight || "",
          row.TrfMix_Weight || "",
          row.Party_Location || "",
          formatDate(row.Trn_Date),
          row.Bill_No || "",
        ]);
        rowStyles.push("normal");
      });

      // Lot Total
      const totals = lotTotals[lotNo];
      sheetData.push([
        "",
        "Lot Total",
        totals.totalPkt,
        "",
        totals.totalInw,
        "",
        totals.totalSaleWeight,
        totals.totalSalePcs,
        totals.avgSaleRate,
        totals.totalAmount,
        totals.totalStock,
        totals.totalStockPcs,
        totals.totalMemoWeight,
        totals.totalMemoPcs
        
      ]);
      rowStyles.push("lotTotal");

      sheetData.push([]);
      rowStyles.push("blank");
    });

    /* ================= GRAND TOTAL ================= */
    sheetData.push([
      "",
      data.length,
      "Grand Total",
      "",
      data.reduce((t, r) => t + (r.Inw_Weight || 0), 0),
      data.reduce((t, r) => t + (r.Inw_Pcs || 0), 0),
      "",
      data.reduce((t, r) => t + (r.Sale_Weight || 0), 0),
      data.reduce((t, r) => t + (r.Sale_Pcs || 0), 0),
      "",
      data.reduce((t, r) => t + (r.Amount || 0), 0),
      data.reduce((t, r) => t + (r.Stock_Weight || 0), 0),
      data.reduce((t, r) => t + (r.Stock_Pcs || 0), 0),
      data.reduce((t, r) => t + (r.Memo_Weight || 0), 0),
      data.reduce((t, r) => t + (r.Memo_Pcs || 0), 0),
    ]);
    rowStyles.push("grandTotal");

    /* ================= CREATE SHEET ================= */
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    /* ================= COLUMN WIDTH ================= */
    ws["!cols"] = [
      { wch: 6 }, { wch: 10 }, { wch: 8 }, { wch: 10 },
      { wch: 12 }, { wch: 14 }, { wch: 10 }, { wch: 10 },
      { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 12 },
      { wch: 22 }, { wch: 12 }, { wch: 10 },
    ];

    /* ================= STYLES ================= */
    const styles = {
      header: {
        font: { bold: true },
        alignment: { horizontal: "center", vertical: "center" },
        fill: { fgColor: { rgb: "D9E1F2" } },
        border: fullBorder()
      },
      lotHeader: {
        font: { bold: true, color: { rgb: "C65911" } },
        fill: { fgColor: { rgb: "FFF2CC" } },
        alignment: { horizontal: "left" }
      },
      lotTotal: {
        font: { bold: true },
        fill: { fgColor: { rgb: "E7E6E6" } },
        border: fullBorder()
      },
      grandTotal: {
        font: { bold: true },
        fill: { fgColor: { rgb: "C6E0B4" } },
        border: fullBorder()
      },
      normal: {
        border: fullBorder()
      }
    };

    function fullBorder() {
      return {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" }
      };
    }

    /* ================= APPLY STYLES ================= */
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellRef]) continue;

        const type = rowStyles[R];
        if (styles[type]) ws[cellRef].s = styles[type];
      }
    }

    /* ================= SAVE ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Lot Stock Detail");
    XLSX.writeFile(wb, "Single_PktLot_Wise_Stock_Detail.xlsx");
  };

const exportToPDF = () => {
  const doc = new jsPDF("landscape", "mm", "a4");

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const companyName = compName.join(",") // 🔹 replace dynamically if needed
  const reportTitle = "SINGLE PACKET LOT WISE STOCK DETAILS";

  // ================= TABLE HEADER =================
  const head = [[
    "Sr",
    "Lot No",
    "Pkt No",
    "Mkt No",
    "Inw Wt",
    "Mix Inw Wt",
    "Sale Wt",
    "Sale Pcs",
    "Sale Rate",
    "Sale Amt",
    "Stock Wt",
    "Stock Pcs",
    "Memo Wt",
    "Memo Pcs",
    "Trf Mix",
    "Location / Party",
    "Date",
    "Doc No"
  ]];

  const body = [];

  // ================= TABLE BODY =================
  Object.entries(groupedData).forEach(([lotNo, rows]) => {
    // Lot Header
    body.push([
      {
        content: `Lot - ${lotNo}`,
        colSpan: 18,
        styles: {
          fontStyle: "bold",
          fillColor: [255, 242, 204],
          halign: "left"
        }
      }
    ]);

    rows.forEach((row, i) => {
      body.push([
        i + 1,
        row.SL_Code,
        row.SPktNo,
        `${row.L_Code}-${row.PktNo}`,
        row.Inw_Weight?.toFixed(2) || "",
        row.MixSngInw_Weight?.toFixed(2) || "",
        row.Sale_Weight?.toFixed(2) || "",
        row.Sale_Pcs || "",
        row.Sale_Rate || "",
        row.Amount || "",
        row.Stock_Weight?.toFixed(2) || "",
        row.Stock_Pcs || "",
        row.Memo_Weight?.toFixed(2) || "",
        row.Memo_Pcs || "",
        row.TrfMix_Weight?.toFixed(2) || "",
        row.Party_Location || "",
        formatDate(row.Trn_Date),
        row.Bill_No || ""
      ]);
    });

    // Lot Total
    const t = lotTotals[lotNo];
    body.push([
      { content: "Lot Total", colSpan: 2, styles: { fontStyle: "bold" } },
      t.totalPkt,
      "",
      t.totalInw.toFixed(2),
      "",
      t.totalSaleWeight.toFixed(2),
      t.totalSalePcs,
      t.avgSaleRate.toFixed(2),
      t.totalAmount.toFixed(2),
      t.totalStock.toFixed(2),
      t.totalStockPcs,
      t.totalMemoWeight.toFixed(2),
      t.totalMemoPcs,
      "",
      "",
      "",
      ""
    ]);
  });

  // ================= AUTO TABLE =================
  autoTable(doc, {
    startY: 20, // leave space for company header
    head,
    body,
    theme: "grid",

    styles: {
      fontSize: 8,
      cellPadding: 2,
      valign: "middle"
    },

    headStyles: {
      fillColor: [217, 225, 242],
      textColor: 0,
      fontStyle: "bold",
      halign: "center"
    },

    didDrawPage: (data) => {
      data.settings.margin.top = 20;
      // ===== COMPANY HEADER (REPEATS EVERY PAGE) =====
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text(companyName, pageWidth / 2, 10, { align: "center" });

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text(reportTitle, pageWidth / 2, 17, { align: "center" });

      doc.setFontSize(9);
      doc.text(
        `Date : ${new Date().toLocaleDateString("en-GB")}`,
        pageWidth - 15,
        10,
        { align: "right" }
      );

      // ===== FOOTER PAGE NUMBER =====
      const pageNo = doc.internal.getNumberOfPages();
      doc.setFontSize(8);
      doc.text(
        `Page ${pageNo}`,
        pageWidth - 15,
        pageHeight - 5,
        { align: "right" }
      );
    }
  });

  // ================= SAVE =================
  doc.save("Single_PktLot_Wise_Stock_Detail.pdf");
};





  return (
    <MainContainer
      pageName="Single PAcket Lot Wise Details"
      breadcrumbs={["Reports", "Single Packet Lot Wise Details"]}
      prevPage={{ show: true, onClick: handleClickPrev }}
    >
      <div className="bg-white p-2 h-screen">
        <Select
          size="sm"
          name={"lcode"}
          label={"Select Lot Nos."}
          color="default"
          eventResizeFeature={true}
          selectionMode="multiple"
          labelPlacement="outside"
          showScrollIndicators={true}
          placeholder={"--select--"}
          className="w-full"
          classNames={{
            label: "text-xs font-semibold",
          }}
          variant="bordered"
          isVirtualized
          items={
            masterData && masterData.length > 0 ? masterData : []
          }
          onSelectionChange={setSelLotNos}
          selectedKeys={selLotNos}
          renderValue={(items) => {
            return (
              <div className="flex gap-2 w-full" >
                {items.map((item) => (
                  <div key={item.SL_Code} className="flex  text-xs">
                    <Chip
                      key={item.SL_Code}
                      label={item.data.SL_Code}
                      onDelete={() => handleDelet(item.key, 'lot')}
                      size="small"
                      color="secondary"
                      variant="outlined"
                      sx={{ height: 22, fontSize: "10px" }}
                    />
                    {/* <Chip size="sm" radius="sm" variant="flat" color="default" className="text-xs h-4" key={item.Q_Code}><strong style={{ fontSize: "0.6rem" }} className=" text-blue-800" > {item.data.Q_Name}</strong></Chip>
                                            <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key, 'purity')} icon={faCircleXmark} /></div> */}
                  </div>

                ))}
              </div>
            );
          }}
        >
          {(list) => (
            <SelectItem
              key={list.SL_Code}
            >
              {list.SL_Code}
            </SelectItem>
          )}
        </Select>
        <div className="flex justify-end my-2 gap-4">
          <button
            onClick={exportToExcel}
            className="px-3 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
          >
            Export Excel
          </button>
          <button
            onClick={exportToPDF}
            className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-green-700"
          >
            Export PDF
          </button>
        </div>
        <div className="overflow-auto max-h-[70vh]">
          <div style={{ padding: "10px" }}>
            <table className="w-full border border-black border-collapse text-[11px]">
              <thead className={stickyHeader}>
                <tr>
                  <th className={thClass}>Sr. No</th>
                  <th className={thClass}>Lot No</th>
                  <th className={thClass}>Pkt No</th>
                  <th className={thClass}>Mkt No</th>
                  <th className={thClass}>Inw.<br />Weight</th>
                  <th className={thClass}>Mix-Sng<br />Inw. Weight</th>
                  <th className={thClass}>Sale<br />Weight</th>
                  <th className={thClass}>Sale<br />Pcs</th>
                  <th className={thClass}>Sale Rate</th>
                  <th className={thClass}>Sale<br />Value</th>
                  <th className={thClass}>Stock<br />Weight</th>
                  <th className={thClass}>Stock<br />Pcs</th>
                  <th className={thClass}>On Memo <br /> Weight</th>
                  <th className={thClass}>On Memo<br /> Pcs</th>
                  <th className={thClass}>Trf. To Mix</th>
                  <th className={thClass}>Stock location / Party</th>
                  <th className={thClass}>Trn.<br />Date</th>
                  <th className={thClass}>Doc. No</th>
                </tr>
              </thead>

              <tbody>
                {Object.entries(groupedData).map(([lotNo, rows]) => {
                  // Calculate lot-wise totals
                  const totalInw = rows.reduce((t, r) => t + (r.Inw_Weight || 0), 0);
                  const totalSaleWeight = rows.reduce((t, r) => t + (r.Sale_Weight || 0), 0);
                  const totalAmount = rows.reduce((t, r) => t + (r.Amount || 0), 0);
                  const totalStock = rows.reduce((t, r) => t + (r.Stock_Weight || 0), 0);

                  return (
                    <Fragment key={lotNo}>
                      {/* Lot Header */}
                      <tr className="bg-orange-50 text-sm text-orange-600 font-semibold">
                        <td className={tdClass} colSpan={18}>
                          Lot - {lotNo}
                        </td>
                      </tr>

                      {/* Lot Rows */}
                      {rows.map((row, i) => (
                        <tr key={i} className={`${row.Stock_Weight <= 0 && row.Memo_Weight <= 0 ? 'bg-pink-50' : row.Stock_Weight <= 0 && row.Memo_Weight > 0 ? 'bg-amber-50' : ''} even:bg-grayy-50`}>
                          <td className={tdRight}>{i + 1}</td> {/* Sr. No */}
                          <td className={tdClass}>{row.SL_Code}</td>
                          <td className={tdClass}>{row.SPktNo}</td>
                          <td className={tdClass}>{row.L_Code + "-" + row.PktNo}</td>
                          <td className={tdRight}>{row.Inw_Weight?.toFixed(2)}</td>
                          <td className={tdClass}>{row.MixSngInw_Weight?.toFixed(2)}</td>
                          <td className={tdRight}>{row.Sale_Weight.toFixed(2) || ""}</td>
                          <td className={tdRight}>{row.Sale_Pcs || ""}</td>
                          <td className={tdRight}>{row.Sale_Rate || ""}</td>
                          <td className={tdRight}>{row.Amount || ""}</td>
                          <td className={tdRight}>{row.Stock_Weight.toFixed(2)}</td>
                          <td className={tdRight}>{row.Stock_Pcs}</td>
                          <td className={tdRight}>{row.Memo_Weight.toFixed(2) || ""}</td>
                          <td className={tdRight}>{row.Memo_Pcs || ""}</td>
                          <td className={tdClass}>{row.TrfMix_Weight.toFixed(2)}</td>
                          <td className={tdClass}>{row.Party_Location}</td>
                          <td className={tdClass}>{formatDate(row.Trn_Date)}</td>
                          <td className={tdClass}>{row.Bill_No}</td>
                        </tr>
                      ))}

                      {/* Lot Total Row
                    <tr className="bg-gray-300 font-semibold">
                      <td className={tdRight} colSpan={4}>Lot Total</td>
                      <td className={tdRight}>{totalInw.toFixed(2)}</td>
                      <td className={tdClass}></td>
                      <td className={tdRight}>{totalSaleWeight.toFixed(2)}</td>
                      <td className={tdClass}></td>
                      <td className={tdRight}>{totalAmount.toFixed(2)}</td>
                      <td className={tdRight}>{totalStock.toFixed(2)}</td>
                      <td colSpan={5} className={tdClass}></td>
                    </tr> */}
                    </Fragment>
                  );
                })}
              </tbody>
              {/* FOOTER */}
              <tfoot className={stickyFooter}>
                {Object.entries(lotTotals).map(([lotNo, totals]) => (
                  <tr key={lotNo} className=" bg-orange-50 text-orange-600  text-sm font-semibold">
                    <td className="text-center" colSpan={2}>Total (Lot- {lotNo})</td>
                    <td className="text-center" >{totals.totalPkt}</td>
                    <td className="text-center" ></td>
                    <td className={tdRight}>{totals.totalInw.toFixed(2)}</td>
                    <td className={tdRight}></td>
                    <td className={tdRight}>{totals.totalSaleWeight.toFixed(2)}</td>
                    <td className={tdRight}>{totals.totalSalePcs}</td>
                    <td className={tdRight}>{totals.avgSaleRate.toFixed(2)}</td>
                    <td className={tdRight}>{totals.totalAmount.toFixed(2)}</td>
                    <td className={tdRight}>{totals.totalStock.toFixed(2)}</td>
                    <td className={tdRight}>{totals.totalStockPcs}</td>
                    <td className={tdRight}>{totals.totalMemoWeight.toFixed(2)}</td>
                    <td className={tdRight}>{totals.totalMemoPcs}</td>
                    <td className={tdRight} colSpan={4}></td>

                  </tr>
                ))}
                <tr className="bg-gray-300 text-sm">
                  <td className={tdRight} colSpan={4}>Grand Total</td>
                  <td className={tdRight}>
                    {data.reduce((t, r) => t + (r.Inw_Weight || 0), 0).toFixed(2)}
                  </td>
                  <td className={tdClass}></td>
                  <td className={tdRight}>
                    {data.reduce((t, r) => t + (r.Sale_Weight || 0), 0).toFixed(2)}
                  </td>
                  <td className={tdClass}></td>
                  <td className={tdClass}></td>
                  <td className={tdRight}>
                    {data.reduce((t, r) => t + (r.Amount || 0), 0).toFixed(2)}
                  </td>
                  <td className={tdRight}>
                    {data.reduce((t, r) => t + (r.Stock_Weight || 0), 0).toFixed(2)}
                  </td>
                  <td className={tdClass}></td>
                  <td colSpan={6} className={tdClass}></td>
                </tr>
              </tfoot>




            </table>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default SinglePktLotWiseStockDetail;
